import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SidenavService } from '../services/sidenav.service';

@Component({
  selector: 'app-search-help',
  templateUrl: './search-help.component.html',
  styleUrls: ['./search-help.component.scss'],
  standalone: true,
  imports: [RouterLink],
})
export class SearchHelpComponent {
  constructor(private sidenavService: SidenavService) {
    this.sidenavService.close();
  }
}
